// extracted by mini-css-extract-plugin
export default {"item":"styles_item__xo0I4","titleWrap":"styles_titleWrap__rCp4h"};